import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import * as React from 'react';
import { AnalyticsTrigger, Button, Notice, Separator } from 'telia-front-react';
import { useStores } from '../../stores/RootStore';
import { FetchStatus } from '../../util/FetchStatus';
import { isReservationTimeWithin15Minutes } from '../../util/TimeUtil';
import CancelReservation from '../CancelReservation';
import ReservationTicketNumberView from './ReservationTicketNumberView';
import ReservationView from './ReservationView';

const StoreReservationAdministration = observer((): React.JSX.Element => {
  const {
    reservationStore: { reservation, reservationUseStatus, reservationCancelStatus, useReservation },
  } = useStores();
  const { translate } = React.useContext(TranslationsContext);

  if (reservationUseStatus === FetchStatus.FETCHED || reservation?.stateCode === 'USED') {
    return <ReservationTicketNumberView />;
  }

  const renderArrivedButton = (): React.JSX.Element => (
    <>
      <p>{translate('reservation.store.administration.arrived.text')}</p>
      <AnalyticsTrigger trigger={{ id: 'Button - Arrival confirmation', callback: 'onClick' }}>
        <Button
          id="store-reservation-arrived-button"
          text={translate('reservation.store.administration.arrived.button')}
          onClick={() => useReservation(reservation)}
          disabled={reservation?.stateCode !== 'RESERVED' || reservationCancelStatus === FetchStatus.FETCHED || !isReservationTimeWithin15Minutes(reservation)}
        />
      </AnalyticsTrigger>
      <Separator spacing="xxsmall" color="invisible" />
    </>
  );

  return (
    <>
      <ReservationView />
      {reservationUseStatus === FetchStatus.ERROR && <Notice type="error">{translate('reservation.store.administration.ticketNumber.failed')}</Notice>}
      {renderArrivedButton()}
      <Separator spacing="small" weight="thin" />
      {reservationCancelStatus !== FetchStatus.FETCHED && (
        <>
          {translate('reservation.store.administration.cancel.text')}
          <Separator spacing="xxsmall" color="invisible" />
        </>
      )}
      <CancelReservation />
    </>
  );
});

export default StoreReservationAdministration;
